import React, { Component } from 'react';

import Routes from './routes';

import FullStory from 'react-fullstory';

import '@babel/polyfill';

import { isProduction } from './util';

import SiteMovedMessage from './siteMoved';

class App extends Component {

  componentWillMount(){
    console.log('Main app component will mount!');
  }

  render() {
    return (
      <div className="App">
        <Routes />
        {isProduction() &&
          <FullStory org="F5WWF" />
        }
        <SiteMovedMessage />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js